import { configureStore } from '@reduxjs/toolkit';
import cookiesReducer from '../features/cookies/cookiesSlice';

export default configureStore({
  reducer: {
    cookies: cookiesReducer,
  },
});
